import styled from "styled-components";

// i don't want any divider for SI so i just put an empty div
export const LobbyHeaderLineSIBox = styled.div`
`;
